// https://app.growthbook.io/features/mccerts-2851_v1-core-nav-promo-signal
export const EXPERIMENT_FLAG = 'mccerts-2851_v1-core-nav-promo-signal'
